import { type QueryClient } from "@tanstack/react-query";
import { type User } from "oidc-client-ts";
import { type AuthContextProps } from "react-oidc-context";
import cleanCache from "src/store/helpers/cache.helper";
import { resetAllSlices } from "src/store/helpers/resetStore.helper";

import { KEYCLOAK_DR_API_ROLES_CLAIM_NAME, KEYCLOAK_APP_ROLES_CLAIM_NAME, KEYCLOAK_ALLOWED_ORGANIZATION } from "./config.helper";

export function signOut(queryClient: QueryClient, auth: AuthContextProps): void {
  resetAllSlices();
  void cleanCache();
  queryClient.removeQueries();
  void auth.signoutRedirect();
}

export function signOutSilent(queryClient: QueryClient, auth: AuthContextProps): void {
  resetAllSlices();
  void cleanCache();
  queryClient.removeQueries();
  void auth.signoutSilent();
}

export function getApiRolesFromUser(user: User | null | undefined): string[] {
  return getRolesFromUser(user, KEYCLOAK_DR_API_ROLES_CLAIM_NAME);
}

export function getAppRolesFromUser(user: User | null | undefined): string[] {
  return getRolesFromUser(user, KEYCLOAK_APP_ROLES_CLAIM_NAME);
}

function getRolesFromUser(user: User | null | undefined, rolesClaimName: string): string[] {
  if (user) {
    const profileRoles = user.profile[rolesClaimName];
    if (profileRoles && Array.isArray(profileRoles)) {
      return profileRoles as string[];
    }
  }
  return [];
}

function getOrganizationsFromUser(user: User): string[] {
  const organizations = user.profile.organization;
  if (organizations && Array.isArray(organizations)) {
    return organizations as string[];
  }
  return [];
}

export function checkUserOrganizationAccess(user: User): boolean {
  return KEYCLOAK_ALLOWED_ORGANIZATION.some((allowedOrganization) => getOrganizationsFromUser(user).includes(allowedOrganization));
}
